import { SignUpButton } from "@clerk/clerk-react";

const HeroSection = () => {
    // Replace 'YOUR_VIDEO_ID' with your actual YouTube video ID
    // Example: if your YouTube URL is https://www.youtube.com/watch?v=dQw4w9WgXcQ
    // Then your VIDEO_ID is: dQw4w9WgXcQ
    const YOUTUBE_VIDEO_ID = "SOlvhricGPM";
    return (
        <section className="bg-[#121212] pt-32 pb-16 px-4 relative">
            {/* Grid Background Pattern */}
            <div 
                className="absolute inset-0 w-full h-full"
                style={{
                    backgroundImage: `
                        linear-gradient(to right, #1a1a1a 1px, transparent 1px),
                        linear-gradient(to bottom, #1a1a1a 1px, transparent 1px)
                    `,
                    backgroundSize: '40px 40px',
                    opacity: '0.2'
                }}
            />

            <div className="max-w-7xl mx-auto text-center relative z-10">
                <h1 className="text-white text-6xl font-bold mb-6 leading-tight">
                    Stop Wasting Weeks on Market Research
                    <br />
                    <span className="text-[#7C3AED]">Find Your Next Product Idea in 10 Minutes</span>
                </h1>
                
                <p className="text-gray-400 text-xl mb-8 max-w-4xl mx-auto">
                    While your competitors spend months analyzing markets, you'll discover trending product opportunities, 
                    validate demand, and spot emerging niches from <strong className="text-white">Reddit discussions</strong>—automatically.
                </p>

                <p className="text-gray-300 text-lg mb-12 max-w-3xl mx-auto">
                    Join other product builders who found their breakthrough ideas before anyone else even knew they existed.
                </p>

                <SignUpButton mode="modal">
                    <button className="bg-[#7C3AED] text-white px-10 py-4 rounded-lg text-xl font-semibold hover:bg-[#6D28D9] transition-colors shadow-lg">
                        Get My First Product Idea Now →
                    </button>
                </SignUpButton>

                <p className="text-gray-500 text-sm mt-4">
                    Free forever • No credit card required • 7-day Pro trial
                </p>

                {/* Product Hunt Badge */}
                <div className="mt-8">
                    <a 
                        href="https://www.producthunt.com/products/problem-spotter?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-problem&#0045;spotter" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-block hover:opacity-90 transition-opacity"
                    >
                        <img 
                            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=996727&theme=light&t=1753292014786" 
                            alt="Problem Spotter - Turn Reddit discussions into product ideas | Product Hunt" 
                            className="w-[250px] h-[54px]"
                        />
                    </a>
                </div>

                <div className="mt-16">
                    {/* YouTube Video Embed */}
                    <div className="relative mx-auto rounded-xl shadow-2xl border border-gray-800 overflow-hidden"
                         style={{
                             maxWidth: '1200px',
                             width: '100%',
                             aspectRatio: '16/9'
                         }}>
                        <iframe
                            src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?rel=0&modestbranding=1&showinfo=0&controls=1`}
                            title="Problem Spotter Demo - Find Product Opportunities from Reddit"
                            className="absolute inset-0 w-full h-full"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;